import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

//emailjs
import emailjs from 'emailjs-com';

const transition = {
  duration: 1.2,
  ease: [0.43, 0.13, 0.23, 0.96],
};
const textTransition = {
  duration: 1,
  ease: [0.43, 0.13, 0.23, 0.96],
};

const Contact = () => {
  const [sent, setSent] = useState(false);
  // Emailjs
  const sendEmail = (e) => {
    e.preventDefault();
    setSent(true);
    emailjs
      .sendForm(
        'service_jxwiuvs',
        'template_6a2t8ai',
        e.target,
        'user_EPwfV8Vd2hn5xmjvIxJn9'
      )
      .then((res) => {
        setSent(true);
      });
    // .catch((err) => console.log(err));
    if (sent) {
      // console.log('Email is sent');
    }
    console.log(sent);
    e.target.reset();
  };

  return (
    <motion.div
      className="contact_page"
      initial={{
        width: '145.8px',
        height: '58px',
        top: '30px',
        right: '15%',
        bottom: 0,
        borderRadius: '4px',
      }}
      animate={{
        width: '100%',
        height: 'auto',
        top: 0,
        bottom: 0,
        right: 0,
        borderRadius: '0px',
        transition: { delay: 0, ...transition },
      }}
    >
      <motion.div
        className="contact_page_inner"
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: { delay: 1, ...textTransition },
        }}
      >
        <div className="contact_page_heading">Get In Touch</div>
        <p>
          I am open to new ideas and collaboration. Have a question or want to
          express your admiration for my work? Send them my way, I'll do my best
          to respond as soon as possible!{' '}
        </p>
        {sent && <p>Email Sent Successfully !</p>}
        <div className="contact_page_form">
          <form onSubmit={sendEmail}>
            <label htmlFor="">Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter you name here"
              required
            />

            <label htmlFor="">Email</label>
            <input
              type="email"
              name="user_email"
              placeholder="Enter you email-id here"
              required
            />

            <label htmlFor="">Message</label>
            <textarea
              name="message"
              id=""
              cols="30"
              rows="10"
              placeholder="Enter you message here"
              required
            ></textarea>

            <button type="submit" className="submit_btn">
              Send
            </button>
          </form>
        </div>
        <Link to="/">
          <div className="home_cta">Back to Home</div>
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default Contact;
